import { render } from "./ResetPasswordCard.vue?vue&type=template&id=04dbab90&scoped=true"
import script from "./ResetPasswordCard.vue?vue&type=script&lang=js"
export * from "./ResetPasswordCard.vue?vue&type=script&lang=js"

import "./ResetPasswordCard.vue?vue&type=style&index=0&id=04dbab90&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04dbab90"]])

export default __exports__